import React, { createContext, useContext, useEffect } from "react";
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import enJSON from "../locale/EN.json";
import hiJSON from "../locale/HI.json";
import guJSON from "../locale/GU.json";
import bnJSON from "../locale/BN.json";
import taJSON from "../locale/TA.json";
import teJSON from "../locale/TE.json";
import knJSON from "../locale/KN.json";
import mrJSON from "../locale/MR.json";

i18n.use(initReactI18next).init({
  resources: {
    ENGLISH: {
      translation: enJSON,
    },
    HINDI: {
      translation: hiJSON,
    },
    GUJARATI: {
      translation: guJSON,
    },
    BENGALI: {
      translation: bnJSON,
    },
    TAMIL: {
      translation: taJSON,
    },
    TELUGU: {
      translation: teJSON,
    },
    KANNADA: {
      translation: knJSON,
    },
    MARATHI: {
      translation: mrJSON,
    },
    NEPALI: {
      translation: enJSON,
    },
    MALAYALAM: {
      translation: enJSON,
    },
  },
  lng: "en",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export const langContext = createContext();

const LocaleProvider = ({ children }) => {
  const { t } = useTranslation();

  const changeLang = (langParam) => {
    if (typeof langParam !== "string") {
      console.error("Invalid language parameter:", langParam);
      return;
    }
    // const currentLang = localStorage.getItem("lang")
    //   ? localStorage.getItem("lang")
    //   : "en";
    // if (currentLang === "en") {
    //   i18n.changeLanguage("hi");
    //   localStorage.setItem("lang", "hi");
    // } else if (currentLang === "hi") {
    //   i18n.changeLanguage("en");
    //   localStorage.setItem("lang", "en");
    // }
    console.log("langParam", langParam)
    i18n.changeLanguage(langParam);
    localStorage.setItem("expAddaLang", langParam);
  };

  useEffect(() => {
    const currentLang = localStorage.getItem("expAddaLang");
    i18n.changeLanguage(currentLang);
  }, []);

  return (
    <langContext.Provider value={{ t, changeLang }}>
      {children}
    </langContext.Provider>
  );
};

const useLocale = () => useContext(langContext);

export { useLocale, LocaleProvider };
